import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';

import {getSeatTicketTraits} from '../../../../helpers/get-seat-traits';

const eventSelector = (state) => state.event;
const featuresSelector = ({gsConfig = {}}) => gsConfig.features;

const deviceSelector = createSelector(
  (state = {}) => state.device,
  (device = {}) => device.type
);

const listingsSelector = createSelector(
  (state = {}) => state.listings,
  (listings = {}) => {
    const {
      hasTickets,
      totalListings,
      availableQuantities = [],
      listingLoading,
      eventPricingSummary = {},
      data = [],
      pricingSummary = {},
      eventStats,
    } = listings;
    const {averageTicketPriceWithCurrency = {}} = pricingSummary;
    const seatTraits = getSeatTicketTraits(eventStats);

    return {
      hasTickets,
      totalListings,
      availableQuantities,
      listingLoading,
      eventPricingSummary,
      data,
      averageTicketPriceWithCurrency,
      seatTraits,
      listings,
    };
  }
);

const mapboxDynamicAttributeSelector = createSelector(eventSelector, (event) => {
  const result = null;
  if (event) {
    const {dynamicAttributes = []} = event;
    const [firstAttribute] = dynamicAttributes.filter((attribute) => attribute.name === 'map_detail_level');
    if (firstAttribute) {
      return {
        mapType: firstAttribute || {},
        mapStatus: firstAttribute.status || 'active',
        mapValue: firstAttribute.value || 'default',
      };
    }
  }

  return result;
});

const mapboxPreviewModeSelector = createSelector(
  featuresSelector,
  (features) => features && features['event.seatmap.mapbox.preview']
);

const controller = new Controller({
  namespace: 'map',
  mapStateToProps(state) {
    return {
      ...eventSelector(state),
      ...mapboxDynamicAttributeSelector(state),
      ...listingsSelector(state),
      mapboxPreviewMode: mapboxPreviewModeSelector(state),
      device: deviceSelector(state),
    };
  },
});

export default controller;
